<template>
  <div class="container">
    <InventoryTargetFileSearchWindow @search="search"/>
    <InventoryTargetFileSearchResult :inventoryTargetFileList="inventoryTargetFileList" :isExistSearchResult="isExistSearchResult" />
  </div>
</template>

<script>
import InventoryTargetFileSearchWindow from '@/components/pages/InventoryTargetFileSearchWindow'
import InventoryTargetFileSearchResult from '@/components/pages/InventoryTargetFileSearchResult'

export default {
  name: 'inventory-target-file-list',
  data () {
    return {
      screenTitle: '[帳簿管理] 棚卸対象ファイル一覧',
      inventoryTargetFileList: [],
      isExistSearchResult: false
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  async created () {
    this.$emit('setMessage', null, false)
    // 棚卸対象ファイル情報操作（取得）API
    await this.axios.get('/api/inventory/file/getall', {
      headers: {
        'Authorization': this.$session.get('accessToken'),
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
      }
    }).then((response) => {
      this.inventoryTargetFileList = response.data.resultList
      if (this.inventoryTargetFileList.length > 0) {
        this.isExistSearchResult = true
      } else {
        this.isExistSearchResult = false
      }
    })
  },

  methods: {
    async search (inventoryName, uploadDateFrom, uploadDateTo, uploadUserName, uploadStatus) {
      this.$emit('setMessage', null, false)
      var params = {
        inventoryName: inventoryName,
        uploadUserName: uploadUserName,
        uploadDateFrom: uploadDateFrom,
        uploadDateTo: uploadDateTo,
        uploadStatus: uploadStatus
      }
      // 棚卸対象ファイル情報操作（取得）API
      await this.axios.get('/api/inventory/file/getall', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        this.inventoryTargetFileList = response.data.resultList
        if (this.inventoryTargetFileList.length > 0) {
          this.isExistSearchResult = true
        } else {
          this.isExistSearchResult = false
        }
      })
    }
  },

  components: {
    InventoryTargetFileSearchWindow,
    InventoryTargetFileSearchResult
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/InventoryTargetFileList.vue